export const ACTIONS = {
    SET_FORM_DATA: 'SET_FORM_DATA',
    SET_SHOW_ERROR: 'SET_SHOW_ERROR',
    SET_ERRORS: 'SET_ERRORS',
    DELETE_ERROR: 'DELETE_ERROR',
    GET_AMOUNT: 'GET_AMOUNT',
    RESET_FIELD: 'RESET_FIELD',
    RESET_MMV: 'RESET_MMV',
    SET_FORM_SUBMITTED: 'SET_FORM_SUBMITTED',
    INITIATE_TRAILERS_INFO: 'INITIATE_TRAILERS_INFO',
    SET_TRAILERS_INFO: 'SET_TRAILERS_INFO',
    SET_TRAILER_INFO_ERROR: 'SET_TRAILER_INFO_ERROR',
    DELETE_TRAILER_INFO_ERROR: 'DELETE_TRAILER_INFO_ERROR',
};
